<template>
  <div id="register" class="container">
    <div class="jacket">
      <div>重置密码</div>
      <div>
        <div style="width:450px;margin:0 auto;margin-bottom:40px">
          <el-steps :space="150" :active="step" align-center>
            <el-step title="填写手机号"></el-step>
            <el-step title="设置新密码"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </div>
      </div>
      <div>
        <div v-show="step == 0">
          <el-form ref="form" label-width="90px">
            <el-row :gutter="20" style="margin-bottom:10px">
              <el-col :span="8" :offset="8">
                <bio-input placeholder="请输入手机号" leftIcon="fa-user" v-model="mobile"></bio-input>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4" :offset="8">
                <bio-input placeholder="请输入验证码" leftIcon="fa-envelope-open-text" v-model="verify"></bio-input>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" plain @click="sendMsg" :disabled="msgDisable">{{btnText}}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div align="center" style="margin-top:20px">
            <el-button @click="next1" type="primary" style="width: 150px;">下一步</el-button>
          </div>
        </div>

        <div v-show="step == 1">
          <el-form ref="form" label-width="90px">
            <el-row>
              <el-col :span="8" :offset="8">
                <el-input
                  placeholder="请输入新密码"
                  type="password"
                  v-model="password"
                  prefix-icon="el-icon-user-solid"
                  show-password
                ></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top:10px">
              <el-col :span="8" :offset="8">
                <el-input
                  placeholder="请再次输入新密码"
                  type="password"
                  v-model="password2"
                  prefix-icon="el-icon-user-solid"
                  show-password
                ></el-input>
              </el-col>
            </el-row>
            <div align="center" style="margin-top:20px">
              <el-button @click="next2" type="primary" style="width: 150px;">下一步</el-button>
            </div>
          </el-form>
        </div>

        <div v-show="step == 2">
          <div align="center">密码重置成功</div>

          <el-row>
            <el-col :span="8" :offset="8">
              <button class="btn" @click="goHome($event)">进入首页</button>
            </el-col>
          </el-row>
        </div>
        <div v-show="step == 3">
          <div align="center">密码重置成功</div>

          <el-row>
            <el-col :span="8" :offset="8">
              <button class="btn" @click="goHome($event)">进入首页</button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bioInput from "../../components/bioInput.vue";
export default {
  components: { bioInput },
  data() {
    return {
      serve: this.$store.state.serve,
      step: 0,
      mobile: "",
      btnText: "获取短信",
      verify: "",
      msgDisable: false,
      password: "",
      password2: ""
    };
  },
  methods: {
    next2() {
      this.axios
        .get(this.serve + "/find_password2", {
          params: {
            mobile: this.mobile,
            verify_code: this.verify,
            password: this.password,
            new_pass: this.password2
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.step = 3;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    next1() {
      this.axios
        .get(this.serve + "/find_password1", {
          params: {
            mobile: this.mobile,
            verify: this.verify
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.step = 1;
          }
        });
    },
    sendMsg() {
      this.axios
        .get(this.serve + "/send_find_note", {
          params: {
            mobile: this.mobile
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "短息已发送",
              type: "success"
            });
            this.btnText = "60s后重新发送";
            this.msgDisable = true;
            var t = 60;
            var that = this;
            var t1 = setInterval(function() {
              t--;
              if (t == 0) {
                clearInterval(t1);
                that.msgDisable = false;
                that.btnText = "获取短信";
              } else {
                that.btnText = t + "s后重新发送";
              }
            }, 1000);

            if (res.data.status == "success") {
            }
          } else {
            if (res.data.msg == "未知错误") {
              this.$message.error("操作失败");
            } else {
              this.$message.error(res.data.msg);
            }
          }
        });
    },
    goHome() {
      this.$router.push("/");
    },
    goHome1() {
      this.$router.push("/login");
    },
    next(e) {
      this.step++;
      e.preventDefault();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
#register {
  .btn {
    background-color: #e2211c;
    width: 100%;
    font-size: 16px;
    padding: 15px 0;
    border: 0;
    display: block;
    color: #fff;
    margin-top: 20px;
    cursor: pointer;
  }
  padding: 20px 0;
  .jacket {
    background-color: #fff;
    padding: 30px 40px;
    padding-bottom: 50px;
    display: block;
    border: 1px solid #dddddd;
  }
  .form {
    .el-checkbox__inner:hover,
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #e2211c;
    }
    width: 380px;
    margin: 0 auto;
    .title {
      color: #e2211c;
      text-align: center;
      margin-bottom: 20px;
      font-size: 17px;
    }
  }
}
</style>